import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Intercom } from '@capacitor-community/intercom';

import { UserService } from '../../services/user.service';
import { SalonService } from '../../services/salon.service';

@Component({
  selector: 'smr-subscription-banner',
  templateUrl: './subscription-banner.component.html',
  styleUrls: ['./subscription-banner.component.scss'],
})
export class SubscriptionBannerComponent  implements OnInit, OnDestroy {
  public sessionObservable;

  public isReadOnly: boolean = false;

  constructor(public userService: UserService,
    private changeDetectorRef: ChangeDetectorRef,
    private platform: Platform,
    private salonService: SalonService) {
  }

  public ngOnInit() {
    this.sessionObservable = this.userService.getSessionMonitor().subscribe((sessionData) => {
      if (sessionData) {
        this.refresh();
      }
    });
  }

  public ngOnDestroy() {
    this.sessionObservable.unsubscribe();
  }

  public refresh() {
    const salon = this.userService.getSalon();
    // don't show anything if the user is on a group plan
    if (salon.planID !== 6) {
      this.isReadOnly = this.salonService.getIsReadOnly();
      this.changeDetectorRef.markForCheck();
    } 
  }

  public contact() {
    if (window && window['Intercom']) {
      const intercom = window['Intercom'];
      intercom('show');
    }
    if(this.platform.is("capacitor")){
      Intercom.displayMessenger();
    }
  }

}
